export default "__VITE_ASSET__T6$jEmds__"